// removed by extract-text-webpack-plugin
module.exports = {"button":"CopyToClipboardButton-button","confirmation":"CopyToClipboardButton-confirmation","visible":"CopyToClipboardButton-visible"};